module.exports = __webpack_public_path__ + "img/ft_computer.aeeb0d78.png";